import React, { useEffect } from "react";
import AllCourses from "../../components/AllCourse/AllCourses";
import Footer from "../../components/Footer/Footer";
import PageTop from "../../components/PageTop/PageTop";
import MainNav from "../../shared/MainNav/MainNav";

export default function Course() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <>
      <MainNav title="Courses" />
      <PageTop pageTitle="All Courses" />
      <AllCourses />
      <Footer />
    </>
  );
}
